import { EmployerAgreementsService_employerAgreementsOverviewServiceGetOverview } from '@festina/life-general-types/life/hooks/EmployerAgreementsService_employerAgreementsOverviewServiceGetOverview'

export const useFetchEmployerAgreementCommands =
  EmployerAgreementsService_employerAgreementsOverviewServiceGetOverview.useSuspenseQuery
